import { emptyApi } from "./emptyApi";

type McpConnectionResponse = {
  mcp_url: string;
  generated: boolean;
};

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getMcpConnectionUrl: build.query<McpConnectionResponse, void>({
      query: () => ({
        url: `/api/inkle/ai_agents/mcp/connection-url/`,
      }),
      providesTags: ["MCP_CONNECTION"],
    }),
    generateMcpConnectionUrl: build.mutation<McpConnectionResponse, void>({
      query: () => ({
        url: `/api/inkle/ai_agents/mcp/connection-url/`,
        method: "POST",
      }),
      invalidatesTags: ["MCP_CONNECTION"],
    }),
    getAdminMcpConnectionUrl: build.query<McpConnectionResponse, void>({
      query: () => ({
        url: `/api/inkle/ai_agents/mcp/admin/connection-url/`,
      }),
      providesTags: ["MCP_CONNECTION"],
    }),
    generateAdminMcpConnectionUrl: build.mutation<McpConnectionResponse, void>({
      query: () => ({
        url: `/api/inkle/ai_agents/mcp/admin/connection-url/`,
        method: "POST",
      }),
      invalidatesTags: ["MCP_CONNECTION"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMcpConnectionUrlQuery,
  useGenerateMcpConnectionUrlMutation,
  useGetAdminMcpConnectionUrlQuery,
  useGenerateAdminMcpConnectionUrlMutation,
} = extendedApi;
